import { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { ShepherdOptionsWithType, ShepherdTourContext } from 'react-shepherd';
import { OrderDetails } from '../../api/fetchAllHEOrder';
import { GO_TO_HE_DASHBOARD, GO_TO_HE_TRIAL_ORDER } from '../../routes/paths';
import { track } from '../../tracking';
import { TrialOrderType } from './TrialOrderHomePage';

export const pharmaSteps = [
    {
        action: 'create-rx',
        text: 'Create prescription (we have taken a sample prescription)',
    },
    {
        action: 'review-cart',
        text: 'Review cart (cart auto-generated from medicines in the sample prescription)',
    },
    {
        action: 'add-address',
        text: 'Add delivery address (you can add your clinic address)',
    },
    {
        action: 'place-order',
        text: 'Place order',
    },
    {
        action: 'order-placed',
        text: 'Order Placed',
    },
];

export const labSteps = [
    {
        action: 'create-rx',
        text: 'Create prescription (we have taken a sample prescription)',
    },
    {
        action: 'review-cart',
        text:
            'Select your preferred lab partner option (Options auto-generated from lab tests in the sample prescription)',
    },
    {
        action: 'apply-discount',
        text: 'Apply discount',
    },
    {
        action: 'add-address',
        text: 'Add delivery address (you can add your clinic address)',
    },
    {
        action: 'select-slot',
        text: 'Select slot for sample collection',
    },
    {
        action: 'place-order',
        text: 'Place order',
    },
    {
        action: 'order-placed',
        text: 'Order Placed',
    },
];

export function Button(): JSX.Element {
    const tour = useContext(ShepherdTourContext);
    return (
        <button id="start-tour" className="hidden" onClick={tour?.start}>
            Start Tour
        </button>
    );
}

export type PopperPlacement = 'right' | 'bottom';

export const FinishedPageFooter: React.FC<{
    type: TrialOrderType;
    orderDetails?: OrderDetails;
    toggleActiveOrder: (order?: OrderDetails) => void;
    isForTrialOrder?: boolean;
}> = ({ type, orderDetails, toggleActiveOrder, isForTrialOrder }) => {
    const history = useHistory();

    const goToHEDashboard = () => {
        history.replace(GO_TO_HE_DASHBOARD('pending', undefined, undefined, true));
        handleCloseTour();
    };

    const tryNowHandler = () => {
        history.replace(GO_TO_HE_TRIAL_ORDER(type === 'pharma' ? 'lab' : 'pharma', 'start'));
        handleCloseTour();
    };

    const handleCloseTour = () => {
        const shepherdTourDivs = document.getElementsByClassName(
            'shepherd-tour-finishpage',
        ) as HTMLCollectionOf<HTMLElement>;
        Array.from(shepherdTourDivs).forEach((ele) => ele && ele.remove());
    };

    if (orderDetails) orderDetails.id = orderDetails.vendor_order_id;
    return (
        <div className="absolute flex items-center justify-end space-x-16 left-16 right-16 bottom-16 p-8 bg-actionPrimary rounded-8 space-x-16">
            <button
                className="px-16 py-10 btn--small primary-btn-v2"
                onClick={goToHEDashboard}
                id="clinic-dashboard"
            >
                <svg
                    className="w-14 h-14 fill-actionPrimary"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M8.25 1.21875L13.75 6.46875C13.9062 6.625 14 6.8125 14 7.03125C14 7.21875 13.9062 7.40625 13.75 7.5625L8.25 12.8125C7.96875 13.0938 7.46875 13.0938 7.1875 12.7812C6.90625 12.5 6.90625 12 7.21875 11.7188L11.375 7.78125H0.75C0.3125 7.78125 0 7.4375 0 7.03125C0 6.59375 0.3125 6.28125 0.75 6.28125H11.375L7.21875 2.3125C6.90625 2.03125 6.90625 1.53125 7.1875 1.25C7.46875 0.9375 7.9375 0.9375 8.25 1.21875Z" />
                </svg>
                <p>View all orders</p>
            </button>

            {/* {isForTrialOrder && (
                <button
                    className="px-16 py-10 btn--small primary-btn-v2"
                    onClick={tryNowHandler}
                    id="try-order"
                >
                    <svg
                        className="w-14 h-14 fill-actionPrimary"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M8.25 1.21875L13.75 6.46875C13.9062 6.625 14 6.8125 14 7.03125C14 7.21875 13.9062 7.40625 13.75 7.5625L8.25 12.8125C7.96875 13.0938 7.46875 13.0938 7.1875 12.7812C6.90625 12.5 6.90625 12 7.21875 11.7188L11.375 7.78125H0.75C0.3125 7.78125 0 7.4375 0 7.03125C0 6.59375 0.3125 6.28125 0.75 6.28125H11.375L7.21875 2.3125C6.90625 2.03125 6.90625 1.53125 7.1875 1.25C7.46875 0.9375 7.9375 0.9375 8.25 1.21875Z" />
                    </svg>
                    <p>Place {type === 'lab' ? 'Medicine' : 'Lab Test'} Trial Order</p>
                </button>
            )} */}

            {isForTrialOrder && (
                <button
                    className="px-16 py-10 btn--small primary-btn-v2"
                    onClick={() => toggleActiveOrder(orderDetails)}
                >
                    <svg
                        className="w-14 h-14 fill-actionPrimary"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M8.25 1.21875L13.75 6.46875C13.9062 6.625 14 6.8125 14 7.03125C14 7.21875 13.9062 7.40625 13.75 7.5625L8.25 12.8125C7.96875 13.0938 7.46875 13.0938 7.1875 12.7812C6.90625 12.5 6.90625 12 7.21875 11.7188L11.375 7.78125H0.75C0.3125 7.78125 0 7.4375 0 7.03125C0 6.59375 0.3125 6.28125 0.75 6.28125H11.375L7.21875 2.3125C6.90625 2.03125 6.90625 1.53125 7.1875 1.25C7.46875 0.9375 7.9375 0.9375 8.25 1.21875Z" />
                    </svg>
                    <p>Cancel {type === 'lab' ? 'Booking' : 'Order'}</p>
                </button>
            )}
        </div>
    );
};

export const stepsForFinishState = (type: TrialOrderType = 'pharma'): ShepherdOptionsWithType[] => [
    {
        id: 'track-timeline',
        attachTo: { element: '#track-timeline', on: 'bottom' as PopperPlacement },
        beforeShowPromise: function (): Promise<void> {
            return new Promise<void>(function (resolve) {
                setTimeout(function () {
                    window.scrollTo(0, 0);
                    resolve();
                }, 500);
            });
        },
        buttons: [
            {
                classes: 'shepherd-button-primary',
                text: 'Next',
                type: 'next',
            },
        ],
        classes: 'mt-16 shepherd-tour-finishpage',
        highlightClass: 'highlight',
        scrollTo: true,
        cancelIcon: {
            enabled: true,
        },
        title: 'Track order status!',
        text: [
            `${
                type === 'pharma'
                    ? 'Your order will be delivered to you today 🚀.'
                    : 'Partner will collect samples based on the selected slot details 🚀.'
            } You can view the order details and track status here.`,
        ],
        when: {
            show: (): void => {
                console.log('show step');
            },
            hide: (): void => {
                console.log('hide step');
            },
            cancel: (): void => {
                track('TRIAL_ORDER_CANCEL_BUTTON_CLICKED', {
                    on: 'go-to-clinic-dashboard',
                });
            },
        },
    },
    {
        id: 'clinic-dashboard',
        attachTo: { element: '#clinic-dashboard', on: 'top' as PopperPlacement },
        beforeShowPromise: function (): Promise<void> {
            return new Promise<void>(function (resolve) {
                setTimeout(function () {
                    window.scrollTo(0, 0);
                    resolve();
                }, 500);
            });
        },
        buttons: [
            {
                classes: 'shepherd-button-primary',
                text: 'Back',
                type: 'back',
            },
            {
                classes: 'shepherd-button-primary',
                text: 'Next',
                type: 'next',
            },
        ],
        classes: '-mt-20 shepherd-tour-finishpage',
        highlightClass: 'highlight',
        scrollTo: true,
        cancelIcon: {
            enabled: true,
        },
        title: 'Wow, your order is placed successfully!',
        text: ['Click below button view your order dashboard'],
        when: {
            show: (): void => {
                console.log('show step');
            },
            hide: (): void => {
                console.log('hide step');
            },
            cancel: (): void => {
                track('TRIAL_ORDER_CANCEL_BUTTON_CLICKED', {
                    on: 'go-to-clinic-dashboard',
                });
            },
        },
    },
];
